// Single source of truth for environment detection
const isElectron = () => {
  // Check for basic Electron indicators
  const hasElectronAPI = window.electronAPI && typeof window.electronAPI === 'object';
  const hasElectronProcess = window.process && window.process.versions && window.process.versions.electron;
  const hasElectronUserAgent = navigator.userAgent && navigator.userAgent.includes('Electron');
  
  // Return true if any Electron indicator is present
  return hasElectronAPI || hasElectronProcess || hasElectronUserAgent;
};
console.log("isElectron: == ?", isElectron())

// Additional environment utilities
export const isWeb = () => !isElectron();
export const isDevelopment = () => process.env.NODE_ENV === 'development';
export const isProduction = () => process.env.NODE_ENV === 'production';

export default isElectron; 